/* tslint:disable */
/* eslint-disable */
/**
 * FeatureServiceApi
 * This describes the API clients use for accessing features
 *
 * The version of the OpenAPI document: 1.1.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */
export enum RolloutStrategyAttributeConditional {
    Equals = 'EQUALS',
    EndsWith = 'ENDS_WITH',
    StartsWith = 'STARTS_WITH',
    Greater = 'GREATER',
    GreaterEquals = 'GREATER_EQUALS',
    Less = 'LESS',
    LessEquals = 'LESS_EQUALS',
    NotEquals = 'NOT_EQUALS',
    Includes = 'INCLUDES',
    Excludes = 'EXCLUDES',
    Regex = 'REGEX'
}



